module.exports = __webpack_public_path__ + "img/copyright_icon.8929073c.png";